const UrlName = 'monitor/v1'
export default API => ({
  // 是否实名
  postIsRealNameAuthentication ({ data, params }) {
    return API({ url: `${UrlName}/user/oauth/isRealNameAuthentication`, method:'post', data, params })
  },
})